import { render } from "./SalesDetails.vue?vue&type=template&id=7dddf940&scoped=true"
import script from "./SalesDetails.vue?vue&type=script&lang=js"
export * from "./SalesDetails.vue?vue&type=script&lang=js"

import "./custom-sales.scss?vue&type=style&index=0&id=7dddf940&lang=scss&scoped=true"
import "./custom-sales-details.scss?vue&type=style&index=1&id=7dddf940&lang=scss&scoped=true"
import "./SalesDetails.vue?vue&type=style&index=2&id=7dddf940&lang=scss&scoped=true"
import "./SalesDetails.vue?vue&type=style&index=3&id=7dddf940&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dddf940"]])

export default __exports__